























































import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  computed,
  PropType,
  ref
} from "@vue/composition-api";
import OccPanel from "@/components/Atoms/OccPanel/index.vue";
import styleVars from "@/assets/styles/vars-for-script.scss";

const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks;

export default defineComponent({
  name: "OccModal",
  components: {
    OccPanel
  },
  props: {
    maxWidth: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: undefined
    },
    height: {
      type: String,
      default: "auto"
    },
    overflowBodyInitial: {
      type: Boolean,
      default: false
    },
    modalId: {
      type: String,
      default: "occ-modal"
    },
    closeButton: {
      type: Boolean,
      default: false
    },
    spacing: {
      type: String as PropType<"small" | "medium">,
      default: "medium",
      validator: (spacing: string) => {
        return ["small", "medium"].includes(spacing);
      }
    },
    backdropColor: {
      type: String as PropType<"default" | "light">,
      default: "default",
      validator: (value: string) => {
        return ["default", "light"].includes(value);
      }
    },
    partialDisplay: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  setup(props, context) {
    const targetElement = ref<Element | null>(null);
    const containerSize = computed(() => {
      const style = {
        width: props.width,
        "max-width": props.maxWidth,
        height: props.height
      };
      return style;
    });
    const onCloseModal = () => {
      if (targetElement.value) {
        enableBodyScroll(targetElement.value);
      }
      context.emit("close");
    };

    onBeforeUnmount(() => {
      clearAllBodyScrollLocks();
    });
    onMounted(() => {
      targetElement.value = document.getElementById(props.modalId);
      if (targetElement.value) {
        disableBodyScroll(targetElement.value);
      }
    });

    const closeButtonColor = styleVars.occFont;

    return {
      targetElement,
      containerSize,
      onCloseModal,
      closeButtonColor
    };
  }
});
